
export default {
  name: 'AllFurnitureViewTrendingFurniturePrice',
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isBoutiquePage() {
      return this.$store.state.metaData?.addons?.head?.isBoutique || false;
    },
  },
  methods: {
    formattedPrice(number) {
      // Here, 'USD' is the currency used in the API; change this if needed
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(number);
    },
  },
};
